<template>
  <acclaro-pagination
      :show-first-page="handleFirst"
      :show-previous-page="handlePrevious"
      :show-next-page="handleNext"
      :show-last-page="handleLast"
      :pagination-details="paginationDetails"
  />
</template>

<script>

import AcclaroPagination from "../AcclaroPagination/AcclaroPagination";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import './references.scss'

export default {
  name: "AccountReferencesPagination",
  components: {AcclaroPagination},
  props: [],
  computed: {
    ...mapState('AccountReferencesStore', [
      'paginationDetails'
    ]),
    ...mapGetters('AccountReferencesStore', [
      'requestUrl'
    ]),
  },
  methods: {
    ...mapMutations('AccountReferencesStore', [
      "updatePaginationDetails",
      "setCurrentPage",
    ]),
    ...mapActions('AccountReferencesStore', [
      "fetchReferences",
    ]),
    handleNext () {
      this.fetchReferences(this.paginationDetails.nextPage.url);
    },
    handleFirst () {
      this.fetchReferences(this.paginationDetails.firstPage.url);
    },
    handleLast () {
      this.fetchReferences(this.paginationDetails.lastPage.url);
    },
    handlePrevious () {
      this.fetchReferences(this.paginationDetails.previousPage.url);
    },
  },
};
</script>

<style>
</style>
